<template>
    <li v-if="content" @click="showContent">
        <a class="dropdown-item fs-16 d-inline-flex align-items-center" role="button">
            <i class="fi fi-rr-guide me-2 text-gray-700"></i>
            {{  trans('general.page.learn_about_this_page') }}
        </a>
    </li>
</template>
<script>

import {HELP_CENTER_CONTENT} from '../../services/HelpCenter';
import HelpContent from "../molecules/HelpContent.vue";
import {mapLangToLocale} from "../../services/LocaleServices";

export default {
    name: "HelpNav",
    data() {
        return {
            content: null,
            locale: mapLangToLocale(document.documentElement.lang)
        }
    },
    methods: {
        initializeHelp() {
            let path = this.getPath();

            Object.keys(HELP_CENTER_CONTENT).forEach(key => {
                if (key.includes('*')) {
                    const prefix = key.split('*')[0];
                    if (path.startsWith(prefix)) {
                        path = key;
                    }
                }
            });

            const content = HELP_CENTER_CONTENT[path];

            if (content !== undefined) {
                if (content.LANGUAGES && content.LANGUAGES.includes(this.locale)) {
                    this.content = content;
                } else {
                    this.content = HELP_CENTER_CONTENT['/'];
                    this.locale = 'en';
                }
            }
        },
        getPath() {
            const url = new URL(window.location.href);
            return url.pathname;
        },
        showContent() {
            this.$showPanel({
                component: HelpContent,
                props: {
                    content: this.content,
                    locale: this.locale
                },
                openOn: 'right',
                width: 620,
                cssClass: 'sidePanel',
            });
        }
    },
    mounted() {
        this.initializeHelp()
    }
}
</script>
